import React from 'react';
import { Anchor, Box, Button, Text } from 'grommet';
import { Terminal } from "grommet-icons"

const SSH = ({ ip }) => {
    return (
        <Box
            justify="center"
            align="center"
            gap="none"
            width="120px"
            background="dark-2"
            alignSelf="center"
            alignContent="center"
            round="xsmall"
        >
            <Anchor alignSelf="center" margin={{ left: "6px", right: "6px" }} href={'ssh://' + ip}>
                <Button plain label={<Text color="white" size="12px" weight="normal">SSH</Text>} margin={{top: "xxsmall"}} hoverIndicator={{ color: "light-1", opacity: "weak" }} icon={<Terminal size="16px" color="white" />} />
            </Anchor>
        </Box>
    )
}

export default SSH
